// extracted by mini-css-extract-plugin
module.exports = {"item":"breadcrumbItem_item__3PpoM","link":"breadcrumbItem_link__2kF6g"};